import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

import { ReactComponent as Icon } from './ColorIcon.svg';

/**
 * @function
 * Auto-generated file.
 */
export const ColorIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(function ColorIcon(props, ref) {
  return (
    <SvgIcon ref={ref} viewBox="0 0 16 16" component={Icon} {...props} />
  );
});
